import { Layout } from "@singularsystems/neo-canvas-grid";
import { IGridLayout } from "@singularsystems/neo-canvas-grid/dist/Grid/Misc/Layouts";
import { Neo } from "@singularsystems/neo-react";
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import IssuerInvestmentAutoComplete from "../../../Domain/Components/IssuerInvestmentAutoComplete";
import { ReportCategory } from "../ReportCategory";
import ShareAllocationListCriteria from "./ShareAllocationListCriteria";

@NeoReport("ShareAllocationList", { category: ReportCategory.IssuerReports })
export default class ShareAllocationListReport extends Report<ShareAllocationListCriteria> {

    constructor() {
        super(ShareAllocationListCriteria);
    }

    public renderCriteria() {
        return <div>
            <Neo.GridLayout md={2}>
                <Neo.FormGroup bind={this.criteria.meta.effectiveDate} />
                
                <Neo.FormGroup>
                    <IssuerInvestmentAutoComplete 
                        bind={this.criteria.meta.issuerInvestmentId}
                        bindDisplay={this.criteria.meta.issuerInvestmentName}
                        useParentCache={true} />

                </Neo.FormGroup>
            </Neo.GridLayout>
        </div>;
    }

    getDefaultGridLayout(criteria?: ShareAllocationListCriteria | undefined, propertyKey?: string | undefined): IGridLayout | undefined {
        return {
            "root": {
                "columns": [
                    {
                        "key": "investorInfo.refNo",
                        "width": 90
                    },
                    {
                        "key": "investorInfo.investor",
                        "width": 290
                    },
                    {
                        "key": "startNo",
                        "suppressTotal": true
                    },
                    {
                        "key": "endNo",
                        "suppressTotal": true
                    }
                ]
            }
        } as Layout.IGridLayout;
    }
}